import React from 'react';
import Button from '../../../components/CustomButtons/ButtonTS';
import SearchIcon from '@material-ui/icons/Search';
import { connect } from 'react-redux';
import { showSystemSearchBar, showSystemGroupSearchBar } from '../../stores/actions/dashboardActions';

interface SearchBarButtonProps {
	location: string;
	isSystemSearchBarVisible: boolean;
	dashboardFilteredSystems: number[];
	dashboardFilteredSystemGroups: number[];
	showSystemSearchBar: (isVisible: boolean) => void;
	showSystemGroupSearchBar: (isVisible: boolean) => void;
}

const SearchBarButton = ({ 
	location,
	isSystemSearchBarVisible,
	dashboardFilteredSystems,
	dashboardFilteredSystemGroups,
	showSystemSearchBar,
	showSystemGroupSearchBar
}: SearchBarButtonProps) => {
	const handleSearchBar = () => {
		location === 'System Groups' ?  showSystemGroupSearchBar(!isSystemSearchBarVisible) : showSystemSearchBar(!isSystemSearchBarVisible);
	};
	return (
		<div style={{ display: location === 'Systems' || location === 'System Group' || location === 'System Groups' ? 'block' : 'none' }}>
			<Button
				color='transparent'
				justIcon
				aria-label='Search-bar-button'
				onClick={handleSearchBar}
				disabled={!!dashboardFilteredSystems?.length || location === 'System Groups' && !!dashboardFilteredSystemGroups?.length }
				style={{ borderRadius: '50%' }}
			>
				<SearchIcon />
			</Button>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		dashboardFilteredSystems: state.dashboard.dashboardFilteredSystems,
		dashboardFilteredSystemGroups: state.dashboard.dashboardFilteredSystemGroups,
		isSystemSearchBarVisible: state.dashboard.isSystemSearchBarVisible,
	};
};
const actions = {
	showSystemSearchBar,
	showSystemGroupSearchBar
};

export default connect(mapStateToProps, actions)(SearchBarButton);
